import { render } from "./NotFound.vue?vue&type=template&id=5a8d6a5a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=5a8d6a5a&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8d6a5a"]])

export default __exports__